import { DropdownSubjectValue, InputData } from './form-input-typing';

const replaceFormInputValue = (
  inputs: InputData[],
  desiredName: string,
  newValue: string | number | (string | number)[] | DropdownSubjectValue,
) => {
  const currentValue = inputs.find(value => value.name === desiredName);

  if (currentValue) {
    currentValue.value = newValue;
  }
};

export default replaceFormInputValue;
